module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "for"
    }
  }), _vm._v("Foreword")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("What happens when you take wonderful whole-food, energy-boosting ingredients, whirl them together in a food processor, and then roll them together lovingly with your hands? You’ll have made a simple, convenient, pop-in-your-mouth, flavorful energy ball to enhance your stamina and put a little pep in your step.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap_small"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("When it comes to snacks, there are plenty of options, but they may not be as healthy as they appear. Granola bars can be chock-full of refined sugars, crackers are sometimes filled with hydrogenated oils, and some fruit snacks have barely a hint of real fruit in them! With so many options, it can be confusing to know what to choose to fuel your body.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("As a nutritionist, people often ask me to recommend convenient snacks that will ward off cravings, hunger pangs, and energy slumps. Energy balls are the answer. These snacks are quick and fun to make and easy to store and carry; plus, they taste amazing.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("We all have busy lives and need the right fuel to give our brains and bodies a steady stream of energy throughout the day. Energy balls fit the bill at any time. Whether it’s "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("a couple of breakfast balls in the morning, a lunch-box ball at midday, a brain-boosting ball when you need extra mental stamina, a performance-enhancing ball for sports, or a bedtime ball to increase libido or promote calming energy in the evening, there’s one to suit your needs.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("The ingredients you use to make the energy balls in this book are superior to any packaged or processed snack. They contain raw nuts, seeds, dried fruits, superfoods, nut flours, nutritional powders, whole grains, and more. All of these are unrefined, natural, and provide ample amounts of vitamins, minerals, healthy fats, proteins, and slow-release carbohydrates for sustained energy.")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("By eating these foods, you can cut out the refined sugars, artificial colors and flavors, and sweeteners found in other snacks that will decrease your energy. Refined and artificial ingredients place a toxic load on the body, forcing it to work even harder to rid them from our system. This in turn essentially robs our bodies of energy, leaving us with that sluggish feeling and those dreaded “crashes.”")]), _vm._v(" "), _c('p', {
    staticClass: "text_noindent"
  }, [_vm._v("While making homemade snacks might not sound like the most efficient route, once you have made your first batch of energy balls, you’ll realize just how easy they are—and after one bite, you’ll be hooked! So what are you waiting for? It’s time to learn how to boost your energy naturally with 100 delicious energy balls.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f0eb4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06-foreword.vue
// module id = 72
// module chunks = 0